export default __webpack_public_path__ + "static/media/fa2.7fb02b59.jpg";